var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1.4698V2.97587H1.5C0.671858 2.97587 0 3.65045 0 4.48194V15.5265C0 16.358 0.671858 17.0326 1.5 17.0326H14.5C15.3281 17.0326 16 16.358 16 15.5265V4.48194C16 3.65045 15.3281 2.97587 14.5 2.97587H12V1.4698C12 1.19254 11.7761 0.967773 11.5 0.967773C11.2239 0.967773 11 1.19254 11 1.4698V2.97587H5V1.4698C5 1.19254 4.77614 0.967773 4.5 0.967773C4.22386 0.967773 4 1.19254 4 1.4698ZM1.5 3.97992C1.22414 3.97992 1 4.20497 1 4.48194V5.98802H15V4.48194C15 4.20497 14.7759 3.97992 14.5 3.97992H1.5ZM1 6.99206V15.5265C1 15.8035 1.22414 16.0285 1.5 16.0285H14.5C14.7759 16.0285 15 15.8035 15 15.5265V6.99206H1Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.71aab6b1a09e11d65a5db7212a4363c0.svg";
export { ForwardRef as ReactComponent };